import { useEffect, useState } from "react";
import CustomSelect from "../CustomSelect";
import { useGlobalContext } from "../../../../../Context/Context";
import UputZaLekarskiForm from "./UputZaLekarskiForm";
import LekarskiIzvestajForm from "./LekarskiIzvestajForm";
import Button from "../../../../Custom/Button/Button";
import axios from "axios";
import FullScreenLoader from "../../../FullScreenLoader/FullScreenLoader";

const vrsteAll = [
  { id: "1", name: "УГОВОР О РАДУ", dbValue: "Ugovor o radu" },
  { id: "2", name: "МА ОБРАЗАЦ", dbValue: "MA obrazac" },
  { id: "3", name: "УПУТ ЗА ЛЕКАРСКИ", dbValue: "Uput za lekarski" },
  { id: "4", name: "ЛЕКАРСКИ ИЗВЕШТАЈ", dbValue: "Lekarski izvestaj" },
  { id: "5", name: "ОБРАЗАЦ БР. 6", dbValue: "Obrazac 6" },
  { id: "6", name: "ТЕСТ", dbValue: "Test" },
  { id: "7", name: "ЗАПИСНИК", dbValue: "Zapisnik" },
  { id: "8", name: "ЛЗО", dbValue: "LZO" },
];

const emptyGeneralData = {
  radnoMesto: { id: -1, name: "" },
  zaposlen: { id: -1, name: "" },
  vrsta: { id: -1, name: "" },
  naziv: "",
  brojDokumenta: "",
  vaziDo: "",
  isScan: false,
};

const inputStyle = {
  width: "100%",
  fontSize: "14px",
  height: "40px",
  padding: "0 10px",
  boxSizing: "border-box",
};

const labelStyle = {
  fontSize: "11px",
  fontWeight: "bold",
  marginBottom: "3px",
  display: "block",
};

function GeneralDataForm({
  fileNewDocument,
  resetFile,
  openFilePicker,
  onClose,
}) {
  const [generalData, setGeneralData] = useState(emptyGeneralData);
  const [radnaMestaAll, setRadnaMestaAll] = useState([]);
  const [zaposleniAll, setZaposleniAll] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [savedSuccess, setSavedSuccess] = useState(false);
  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    axios
      .post(`${baseUrl}/evidencija6/get_lookups.php`, {
        company_id: selectedMainEntity.company_id,
      })
      .then(({ data }) => {
        if (data.status === 200) {
          setRadnaMestaAll(data.radna_mesta || []);
          setZaposleniAll(data.zaposleni || []);
        }
      })
      .catch(console.error);
  }, [selectedMainEntity?.company_id, baseUrl]);

  useEffect(() => {
    if (fileNewDocument) {
      setSavedSuccess(false);
    }
  }, [fileNewDocument]);

  const filteredZaposleni =
    generalData.radnoMesto.id === -1
      ? zaposleniAll
      : zaposleniAll.filter(
          (z) => String(z.workplace_id) === String(generalData.radnoMesto.id),
        );

  const filteredRadnaMesta =
    generalData.zaposlen.id === -1
      ? radnaMestaAll
      : radnaMestaAll.filter((rm) => {
          const z = zaposleniAll.find(
            (z) => String(z.id) === String(generalData.zaposlen.id),
          );
          return z ? String(rm.id) === String(z.workplace_id) : true;
        });

  const handleRadnoMestoChange = (rm) => {
    setGeneralData((prev) => ({
      ...prev,
      radnoMesto: rm,
      zaposlen:
        prev.zaposlen.id === -1 ||
        zaposleniAll.some(
          (z) =>
            String(z.id) === String(prev.zaposlen.id) &&
            String(z.workplace_id) === String(rm.id),
        )
          ? prev.zaposlen
          : { id: -1, name: "" },
    }));
  };

  const handleZaposlenChange = (z) => {
    const zData = zaposleniAll.find((emp) => String(emp.id) === String(z.id));

    if (zData && zData.workplace_id) {
      const rm = radnaMestaAll.find(
        (r) => String(r.id) === String(zData.workplace_id),
      );

      setGeneralData((prev) => ({
        ...prev,
        zaposlen: { id: z.id, name: z.name },
        radnoMesto: rm ? { id: rm.id, name: rm.name } : prev.radnoMesto,
      }));
    } else {
      setGeneralData((prev) => ({ ...prev, zaposlen: z }));
    }
  };

  const handleSacuvaj = async () => {
    if (generalData.zaposlen.id === -1 || generalData.vrsta.id === -1) {
      alert("Odaberi zaposlenog i vrstu dokumenta.");
      return;
    }

    const formData = new FormData();
    formData.append("employee_id", generalData.zaposlen.id);
    formData.append("vrsta", generalData.vrsta.name);
    formData.append("naziv", generalData.naziv || generalData.vrsta.name);
    formData.append("broj_dokumenta", generalData.brojDokumenta);
    formData.append("datum_isteka", generalData.vaziDo || "");
    formData.append("is_scan", generalData.isScan ? "1" : "0");

    if (fileNewDocument) formData.append("file", fileNewDocument);

    setIsLoading(true);
    try {
      const { data } = await axios.post(
        `${baseUrl}/zaposleni/create_document.php`,
        formData,
      );

      if (data.status === 200) {
        setGeneralData(emptyGeneralData);
        setSavedSuccess(true);
        resetFile?.();
        alert("Dokument uspešno sačuvan.");
        window.dispatchEvent(new CustomEvent("documentAdded"));
      } else {
        alert(data.message || "Greška pri čuvanju.");
      }
    } catch (e) {
      console.error(e);
      alert("Došlo je do greške na serveru.");
    }
    setIsLoading(false);
  };

  const handleOdustani = () => {
    if (savedSuccess) {
      resetFile?.();
      onClose?.(); // zatvara celu komponentu
    } else {
      setGeneralData(emptyGeneralData);
      setSavedSuccess(false);
      resetFile?.();
    }
  };

  const onChange = (newValue, key) =>
    setGeneralData((prev) => ({ ...prev, [key]: newValue }));

  const isUput = generalData.vrsta.name === "УПУТ ЗА ЛЕКАРСКИ";
  const isLekarski = generalData.vrsta.name === "ЛЕКАРСКИ ИЗВЕШТАЈ";
  const showExtraFields = generalData.vrsta.id !== -1 && !isUput && !isLekarski;

  if (isLoading) return <FullScreenLoader />;

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "flex-end",
        marginTop: "20px",
        flexWrap: "wrap",
      }}
    >
      <CustomSelect
        label={dictionary["radnoMesto"]}
        allValues={filteredRadnaMesta}
        selectedValue={generalData.radnoMesto}
        onSelectChange={handleRadnoMestoChange}
        readOnly={savedSuccess}
      />
      <CustomSelect
        label={dictionary["imeIPrezime"]}
        allValues={filteredZaposleni}
        selectedValue={generalData.zaposlen}
        onSelectChange={handleZaposlenChange}
        readOnly={savedSuccess}
      />
      <CustomSelect
        label={dictionary["vrstaDokumenta"]}
        allValues={vrsteAll}
        selectedValue={generalData.vrsta}
        onSelectChange={(v) => onChange(v, "vrsta")}
        readOnly={savedSuccess}
      />

      {showExtraFields && (
        <>
          <div style={{ flex: "1 1 200px" }}>
            <label style={labelStyle}>
              {dictionary["nazivDokumenta"] || "NAZIV DOKUMENTA"}
            </label>
            <input
              style={inputStyle}
              value={generalData.naziv}
              onChange={(e) => onChange(e.target.value, "naziv")}
              placeholder="Npr. Test zaštite od požara"
            />
          </div>

          <div>
            <label style={labelStyle}>{dictionary["brojDokumenta"]}</label>
            <input
              style={inputStyle}
              value={generalData.brojDokumenta}
              onChange={(e) => onChange(e.target.value, "brojDokumenta")}
              placeholder={dictionary["brojDokumenta"]}
            />
          </div>

          <div>
            <input
              type="date"
              style={inputStyle}
              value={generalData.vaziDo}
              onChange={(e) => onChange(e.target.value, "vaziDo")}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              height: "40px",
            }}
          >
            <input
              type="checkbox"
              id="isScan"
              checked={generalData.isScan}
              onChange={(e) => onChange(e.target.checked, "isScan")}
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
            />
            <label
              htmlFor="isScan"
              style={{ fontWeight: "bold", cursor: "pointer" }}
            >
              SCAN
            </label>
          </div>
        </>
      )}

      {isUput && (
        <UputZaLekarskiForm
          fileNewDocument={fileNewDocument}
          generalData={generalData}
          setGeneralData={setGeneralData}
        />
      )}

      {isLekarski && (
        <LekarskiIzvestajForm
          fileNewDocument={fileNewDocument}
          generalData={generalData}
          setGeneralData={setGeneralData}
          handleSacuvaj={handleSacuvaj}
        />
      )}

      {/* TASTERI - uvek vidljivi kad je savedSuccess, inace samo kad showExtraFields */}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "10px",
        }}
      >
        {savedSuccess ? (
          <>
            <div
              onClick={handleOdustani}
              style={{ width: "150px", height: "40px" }}
            >
              <Button activation={true} style={{ fontWeight: "bold" }}>
                {dictionary["odustani"]}
              </Button>
            </div>
            <div
              onClick={() => openFilePicker?.()}
              style={{ width: "180px", height: "40px" }}
            >
              <Button activation={true} style={{ fontWeight: "bold" }}>
                + ДОДАЈ НОВИ
              </Button>
            </div>
          </>
        ) : (
          showExtraFields && (
            <>
              <div
                onClick={handleOdustani}
                style={{ width: "150px", height: "40px" }}
              >
                <Button activation={true} style={{ fontWeight: "bold" }}>
                  {dictionary["odustani"]}
                </Button>
              </div>
              <div
                onClick={() => handleSacuvaj()}
                style={{ width: "150px", height: "40px" }}
              >
                <Button activation={true} style={{ fontWeight: "bold" }}>
                  {dictionary["sacuvaj"]}
                </Button>
              </div>
            </>
          )
        )}
      </div>
    </div>
  );
}

export default GeneralDataForm;
